import React from "react";
import { ShopGrid } from "../ShopGrid/ShopGrid";
import line from "../assets/line.svg";
import styles from "./ShopSection.module.css";

function ShopSection({ setHidden, setShowShop }) {
  return (
    <div id="shop_section" className={styles.container}>
      <img src={line} alt="Section line" className={styles.line}></img>
      <h2 className={styles.title}>Descubrí mis amigurumis</h2>
      <ShopGrid setShowShop={setShowShop} setHidden={setHidden}></ShopGrid>
    </div>
  );
}

export { ShopSection };
